import { render, staticRenderFns } from "./InviteCoInvestigatorsForm.vue?vue&type=template&id=3e3c94b6"
import script from "./InviteCoInvestigatorsForm.vue?vue&type=script&lang=js"
export * from "./InviteCoInvestigatorsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports